import { render } from "./Edits.vue?vue&type=template&id=dbbb3954&scoped=true"
import script from "./Edits.vue?vue&type=script&lang=js"
export * from "./Edits.vue?vue&type=script&lang=js"

import "./Edits.vue?vue&type=style&index=0&id=dbbb3954&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbb3954"]])

export default __exports__